var _effectorFileName = "/builds/gmini/front-common/src/components/ImportErrorNotify/ImportErrorNotify.tsx";
import "core-js/modules/es.function.name.js";
import { forwardRef } from 'react';
import { RoundedCross } from '@gmini/ui-kit';
import { SnackbarContent, useSnackbar } from 'notistack';
import { Body, Anchor, Title, Wrapper, TitleWrapper, ArrowRight } from "./ImportErrorNotify.styled";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var ImportErrorNotify = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var name = _ref.name,
      text = _ref.text,
      version = _ref.version;

  var _useSnackbar = useSnackbar(),
      closeSnackbar = _useSnackbar.closeSnackbar;

  return /*#__PURE__*/_jsx(SnackbarContent, {
    ref: ref,
    children: /*#__PURE__*/_jsxs(Wrapper, {
      children: [/*#__PURE__*/_jsxs(TitleWrapper, {
        children: [/*#__PURE__*/_jsxs(Title, {
          children: ["\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 ", name, "(v", version, ")"]
        }), /*#__PURE__*/_jsx(RoundedCross, {
          color: "#fff",
          onClick: function onClick() {
            return closeSnackbar();
          }
        })]
      }), /*#__PURE__*/_jsx(Body, {
        children: text
      }), /*#__PURE__*/_jsxs(Anchor, {
        target: "_blank",
        href: "https://gmini.freshdesk.com/a/solutions/articles/67000697254",
        children: ["\u041E\u0431\u0449\u0438\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F \u043C\u043E\u0434\u0435\u043B\u0438 ", /*#__PURE__*/_jsx(ArrowRight, {
          color: "#fff"
        })]
      })]
    })
  });
});
ImportErrorNotify.displayName = 'ImportErrorNotify';